/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetPublishingCartQueryVariables = Exact<{
	filter?: Types.Publishing_Books_Filter | null | undefined;
}>;

export type GetPublishingCartQuery = {
	Publishing_Books: Array<{
		id: string;
		title: string | null;
		format: string;
		product: {
			id: string;
			currency: string;
			price: number;
			sku: string;
			sale_price: number | null;
			can_pre_order: boolean;
			is_stock_limited: boolean | null;
		} | null;
		featured_image: {
			filename_disk: string | null;
			width: number | null;
			height: number | null;
		} | null;
		authors: Array<{
			Publishing_Authors_And_Artists_id: { full_name: string | null } | null;
		} | null> | null;
		artists: Array<{
			Publishing_Authors_And_Artists_id: { full_name: string | null } | null;
		} | null> | null;
		series: { title: string | null } | null;
	}>;
};

export const GetPublishingCartDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getPublishingCart' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'filter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Publishing_Books_filter' },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Publishing_Books' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'filter' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'format' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'product' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'currency' },
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'price' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'sku' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'sale_price' },
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'can_pre_order' },
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'is_stock_limited' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'featured_image' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ImageWithDimensions' },
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'authors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: {
													kind: 'Name',
													value: 'Publishing_Authors_And_Artists_id',
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'full_name' },
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artists' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: {
													kind: 'Name',
													value: 'Publishing_Authors_And_Artists_id',
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'full_name' },
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'series' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageWithDimensions' },
			typeCondition: {
				kind: 'NamedType',
				name: { kind: 'Name', value: 'directus_files' },
			},
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'filename_disk' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'height' } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetPublishingCartQuery,
	GetPublishingCartQueryVariables
>;
